import { render, staticRenderFns } from "./FamilialLarge.vue?vue&type=template&id=26775494&"
import script from "./FamilialLarge.vue?vue&type=script&lang=js&"
export * from "./FamilialLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports